import { BaseModel } from "../../../vendor_core/core/src/model/BaseModel";
import BURCascadeReelGroup from "../../src/view/BURCascadeReelGroup";
import BUREnergyMetersView from "../view/BUREnergyMetersView";
import { CoinColor, MaybeUndefined } from "../types/BURGameTypes";
import IBURReelsData, {
    IMeterConfig,
    IMetersProgress,
    IMeterState
} from "../types/IBURReelsModel";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { GameLayers } from "../enums/GameLayers";

class BURReelsModel extends BaseModel<IBURReelsData> {
    private reelsGroup: MaybeUndefined<BURCascadeReelGroup> = undefined;
    private energyMetersView: MaybeUndefined<BUREnergyMetersView> = undefined;
    private reelSetIndex: number = 0;
    private coinsMap: Map<CoinColor, number> = new Map([
        ["Blue", 12],
        ["Red", 13],
        ["Yellow", 14]
    ]);
    private meterConfig: MaybeUndefined<IMeterConfig> = undefined;
    private meterState: IMeterState[] = [];
    private metersProgress: MaybeUndefined<IMetersProgress> = undefined;
    private preTriggerMetersProgress: MaybeUndefined<IMetersProgress> =
        undefined;
    private preTriggerCombo: CoinColor[] = [];
    private lastFinalView: number[][] = [];

    public get reels(): BURCascadeReelGroup {
        if (this.reelsGroup === undefined) {
            throw new Error("ReelsGroup not initialised");
        }
        return this.reelsGroup;
    }

    public get shake_layers() {
        return [
            ViewManager.getLayer(DefaultLayers.Banners),
            ViewManager.getLayer(DefaultLayers.Reels),
            ViewManager.getLayer(DefaultLayers.ReelsBack),
            ViewManager.getLayer(GameLayers.Platform),
            ViewManager.getLayer(GameLayers.BlueChest),
            ViewManager.getLayer(GameLayers.YellowChest),
            ViewManager.getLayer(GameLayers.RedChest)
        ];
    }

    public get energy_meters(): BUREnergyMetersView {
        if (this.energyMetersView === undefined) {
            throw new Error("EnergyMeters not initialised");
        }
        return this.energyMetersView;
    }

    public get reelset_index(): number {
        return this.reelSetIndex;
    }

    public get wild_id() {
        return 1;
    }

    public get mystery_symbol_id() {
        return 20;
    }

    public get fs_mystery_symbol_id() {
        return 21;
    }

    public get energy_coin_ids() {
        return this.coinsMap;
    }

    public get meter_config() {
        return this.meterConfig;
    }

    public get meter_state() {
        return this.meterState;
    }

    public get meters_progress() {
        return this.metersProgress;
    }

    public get pre_trigger_meters_progress() {
        return this.preTriggerMetersProgress;
    }

    public get pre_trigger_combo() {
        return this.preTriggerCombo;
    }

    public get last_final_view() {
        return this.lastFinalView;
    }

    public setLastFinalView(payload: number[][]) {
        this.lastFinalView = payload;
    }

    public setReels(payload: BURCascadeReelGroup) {
        this.reelsGroup = payload;
    }

    public setEnergyMeters(payload: BUREnergyMetersView) {
        this.energyMetersView = payload;
    }

    public setReelsetIndex(payload: number) {
        this.reelSetIndex = payload;
    }

    public setMeterConfig(payload: IMeterConfig) {
        this.meterConfig = payload;
    }

    public setMeterState(payload: MaybeUndefined<IMeterState[]>) {
        this.meterState = payload ?? [];
    }

    public setMetersProgress(payload: MaybeUndefined<IMetersProgress>) {
        this.metersProgress = payload;
    }

    public setPreTriggerMetersProgress(
        payload: MaybeUndefined<IMetersProgress>
    ) {
        this.preTriggerMetersProgress = payload;
    }

    public setPreTriggerCombo(payload: CoinColor[]) {
        this.preTriggerCombo = payload;
    }
}

export default new BURReelsModel();
